export default function Reports() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Reports</h1>
      <p className="text-gray-600">View and manage reports</p>
    </div>
  );
}


